// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3drMA","Name":"App_Name__TG2OX"};